import type { ComponentType } from "preact";
import { useEffect, useState } from "preact/hooks";
import { GameView } from "./GameView.tsx";
import { Home } from "./Home.tsx";

export const identity = {
  get name() {
    return localStorage.getItem("rw.name") ?? "";
  },
  set name(v: string) {
    localStorage.setItem("rw.name", v);
  },
  /** Device token: anonymous stable identity for stats (no accounts). */
  get token() {
    let t = localStorage.getItem("rw.token");
    if (!t) {
      t = crypto.randomUUID();
      localStorage.setItem("rw.token", t);
    }
    return t;
  },
};

const roomFromPath = () => /^\/r\/([a-z0-9-]{2,24})\/?$/.exec(location.pathname)?.[1];

export function navigate(path: string) {
  history.pushState(null, "", path);
  dispatchEvent(new PopStateEvent("popstate"));
}

/** /lab/audio: the sound lab, loaded on demand so it stays out of the game bundle. */
function Lab() {
  const [C, setC] = useState<ComponentType>();
  useEffect(() => {
    void import("./AudioLab.tsx").then((m) => setC(() => m.AudioLab));
  }, []);
  return C ? <C /> : null;
}

export function App() {
  const [room, setRoom] = useState(roomFromPath());
  const [, bump] = useState(0);
  useEffect(() => {
    const on = () => {
      setRoom(roomFromPath());
      bump((n) => n + 1);
    };
    addEventListener("popstate", on);
    return () => removeEventListener("popstate", on);
  }, []);
  if (location.pathname.startsWith("/lab/audio")) return <Lab />;
  if (room && identity.name) return <GameView key={room} room={room} />;
  return <Home pendingRoom={room} />;
}
